export enum EProofType {
    WRITTEN = "written",
    VIDEO = "video"
}